export default __webpack_public_path__ + "static/SoehneKraftig-7c2d33bf202adfab587f20c195a75b5d.woff2";